import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  Button,
  Spinner,
  Alert,
  AlertIcon,
  Checkbox,
  CheckboxGroup,
  Stack,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import axios from "axios";
import { getToken, canManageData } from "utils/auth";
import config from "config";
import { useHistory } from "react-router-dom";

const AddIndividual = () => {
  const toast = useToast();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [families, setFamilies] = useState([]);

  useEffect(() => {
    if (!canManageData()) {
      toast({
        title: "Access Restricted",
        description: "Only administrators and moderators can add individuals.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      history.push("/txd/individuals");
    }
  }, []);
  const [individual, setIndividual] = useState({
    individual_code: '',
    status: "Unknown",
    sex: "Unknown",
    year_of_birth: null,
    month_of_birth: null,
    day_of_birth: null,
    kinship: "",
    family_code: "",
    family_history: "Unknown",
    consanguinity: "Unknown",
    geographical_origin: "Unknown",
    medical_data: {
      age_at_onset_months: null,
      age_at_onset_years: null,
      age_at_diagnosis_months: null,
      age_at_diagnosis_years: null,
      age_at_study_months: null,
      age_at_study_years: null,
      year_of_blood_sampling: null,
      month_of_blood_sampling: null,
      day_of_blood_sampling: null,
      year_of_dna_extraction: null,
      month_of_dna_extraction: null,
      day_of_dna_extraction: null,
    },
    genetic_data: {
      xp_group: "Unknown",
      exon: "",
      gene_sequencing: "",
      genotype: "",
      mutation_c: "",
      mutation_p: "",
      ngs: "TGS",
      remarks: "",
    },
  });

  const statusOptions = ["Healthy", "Patient", "Unknown"];
  const yesNoUnknown = ["Yes", "No", "Unknown"];
  const kinshipOptions = [
    "Affected Sib",
    "Father",
    "Mother",
    "Brother",
    "Sister",
    "Paternal Grandfather",
    "Maternal Grandfather",
    "Paternal Grandmother",
    "Maternal Grandmother",
    "Uncle",
    "Cousin",
    "Other",
  ];
  const xpGroupOptions = ["XPA", "XPB", "XPC", "XPD", "XPE", "XPF", "XPG", "XPV", "Unknown"];

  const formBgColor = useColorModeValue("white", "gray.700");
  const formShadowColor = useColorModeValue("md", "dark-lg");
  const textColor = useColorModeValue("teal.500", "teal.300");
  const inputBgColor = useColorModeValue("gray.100", "gray.600");
  const inputTextColor = useColorModeValue("black", "white");
  const buttonColor = useColorModeValue("teal", "teal.400");

  const [otherGeo1, setOtherGeo1] = useState("");
  const [otherGeo2, setOtherGeo2] = useState("");

  const [geo1, setGeo1] = useState("Unknown");
  const [geo2, setGeo2] = useState("Unknown");

  const [otherKinship, setOtherKinship] = useState("");

  const [enableSecondGeo, setEnableSecondGeo] = useState(false);

  useEffect(() => {
    const fetchFamilies = async () => {
      const token = getToken()
      try {
        const response = await axios.get(`${config.API_URL}/individuals/families`, {
          headers: { Authorization: `Bearer ${token}` }});
        setFamilies(response.data);
        console.log(response.data)
      } catch (err) {
        setError("Failed to fetch families.");
      } finally {
        setLoading(false);
      }
    };

    fetchFamilies();
  }, []);

  const handleChange = (section, key, value) => {
    if (section) {
      setIndividual((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [key]: value,
        },
      }));
    } else {
      setIndividual((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedKinship =
      individual.kinship === "Other" && otherKinship ? otherKinship : individual.kinship;
    const rawXpGroup = individual.genetic_data.xp_group || "";
    const updatedXpGroup = rawXpGroup.toLowerCase().includes("unknown") ? "Unknown" : rawXpGroup;

    let fg1 = geo1
    let fg2 = geo2
    if(enableSecondGeo){
      if(geo1 === "Other")
        fg1 = otherGeo1
      if(geo2 === "Other")
        fg2 = otherGeo2
    }
    else{
      if(geo1 === "Other")
        fg1 = otherGeo1
      fg2 = null
    }

    
    

    if (fg1 === "Unknown" && fg2) {
      [fg1, fg2] = [fg2, fg1];
    }
    if (fg1 === fg2){
      final_geographical_origin = fg1
    }

    let final_geographical_origin = fg1 ? (fg2 ? fg1 + "|" + fg2 : fg1) : "Unknown"
    

    console.log(final_geographical_origin)

    try {
      const token = getToken()
      console.log(individual)
      await axios.post(`${config.API_URL}/individual/addOne`, {
        ...individual,
        kinship: updatedKinship,
        geographical_origin : final_geographical_origin,
        genetic_data: { ...individual.genetic_data, xp_group: updatedXpGroup }

      } , {
        headers: { Authorization: `Bearer ${token}` }});
      toast({
        title: "Individual added.",
        description: "A new individual has been successfully created.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      history.push('/txd/individuals/info/'+individual.individual_code);

    } catch (err) {
      toast({
        title: "Error adding individual.",
        description: "There was an error creating the new individual.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" color="teal.500" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Flex>
    );
  }

  return (
    <Flex direction="column" px="6">
      <Box p={6} bg="white" shadow="md" borderRadius="lg" backgroundColor={formBgColor}>
        <Heading size="lg" mb={6} color="teal.500">
          Add New Individual
        </Heading>
        <form onSubmit={handleSubmit}>
          {/* General Information */}

          {/* Family Selection */}
          <FormControl mb={4}>
  <FormLabel>Family Code</FormLabel>
  <Select
    value={individual.family_code}
    onChange={(e) => {
      // Reset individual code when the family code changes
      handleChange(null, "family_code", e.target.value);
      // Clear individual_code when family changes
      handleChange(null, "individual_code", ""); 
    }}
  >
    <option value="">Select family</option>
    {families.map((family) => (
      <option key={family.family_code} value={family.family_code}>
        {family.family_code}
      </option>
    ))}
  </Select>
</FormControl>

<FormControl mb={4}>
  <FormLabel>Individual Code</FormLabel>
  <Flex align="center">
    {/* Non-editable family code + dash */}
    <Box
      px={3}
      py={2}
      bg="gray.100"
      borderWidth={1}
      borderColor="gray.300"
      borderRadius="md"
      fontWeight="bold"
      color={buttonColor}
      textColor={textColor}
    >
      {individual.family_code ? `${individual.family_code}-` : "No Family Selected"}
    </Box>

    {/* Editable part for the individual code */}
    <Input
      backgroundColor={inputBgColor}
      textColor={inputTextColor}
      placeholder="Enter unique identifier"
      value={individual.individual_code?.replace(
        `${individual.family_code}-`,
        ""
      ) || ""}
      onChange={(e) => {
        const input = e.target.value;

        // Ensure only numbers and dashes are allowed
        const validInput = input.replace(/[^0-9-]/g, "");

        // Limit the input to 10 characters
        const truncatedInput = validInput.substring(0, 10);

        // Update the full individual_code state
        const familyCode = individual.family_code || "";
        handleChange(null, "individual_code", `${familyCode}-${truncatedInput}`);
      }}
      isDisabled={!individual.family_code} // Disable if no family code is selected
      maxWidth="200px" // Adjust width to fit well with the prefix box
      ml={2} // Add spacing between prefix and input
    />
  </Flex>
</FormControl>




          <FormControl mb={4}>
            <FormLabel>Status</FormLabel>
            <Select required
              value={individual.status}
              onChange={(e) => handleChange(null, "status", e.target.value)}
            >
              <option value="">Select status</option>
              {statusOptions.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Sex</FormLabel>
            <Select
              value={individual.sex}
              onChange={(e) => handleChange(null, "sex", e.target.value)}
            >
              <option value="">Select sex</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="Unknown">Unknown</option>
            </Select>
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Date of Birth</FormLabel>
            <Flex gap={4}>
              {/* Year of Birth */}
              <Select
                flex="1"
                value={individual.year_of_birth || ""}
                onChange={(e) => handleChange(null, "year_of_birth", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Year</option>
                {[...Array(125)].map((_, index) => {
                  const year = new Date().getFullYear() - index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Select>

              {/* Month of Birth */}
              <Select
                flex="1"
                value={individual.month_of_birth || ""}
                onChange={(e) => handleChange(null, "month_of_birth", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </Select>

              {/* Day of Birth */}
              <Select
                flex="1"
                value={individual.day_of_birth || ""}
                onChange={(e) => handleChange(null, "day_of_birth", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Select>
            </Flex>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Kinship</FormLabel>
            <Select
              value={individual.kinship}
              onChange={(e) => handleChange(null, "kinship", e.target.value)}
            >
              {kinshipOptions.map((kinship) => (
                <option key={kinship} value={kinship}>
                  {kinship}
                </option>
              ))}
            </Select>
            {individual.kinship === "Other" && (
              <Input
              backgroundColor={inputBgColor}
      textColor={inputTextColor}
                mt={2}
                placeholder="Specify kinship"
                value={otherKinship}
                onChange={(e) => setOtherKinship(e.target.value)}
              />
            )}
          </FormControl>

          {/* Family Information */}
          <Heading size="md" mt={6} mb={4}>
            Family Information
          </Heading>
          <FormControl mb={4}>
            <FormLabel>Consanguinity</FormLabel>
            <Select
              value={individual.consanguinity}
              onChange={(e) => handleChange(null, "consanguinity", e.target.value)}
            >
              {yesNoUnknown.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Family History</FormLabel>
            <Select
              value={individual.family_history}
              onChange={(e) => handleChange(null, "family_history", e.target.value)}
            >
              {yesNoUnknown.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
          </FormControl>

          {/* Medical Data */}
          <Heading size="md" mt={6} mb={4}>
            Medical Data
          </Heading>

          {/* Age at Onset */}
          <Flex mb={4} direction="row" gap={4}>
            <FormControl>
              <FormLabel>Age at Onset (Months)</FormLabel>
              <Input
              backgroundColor={inputBgColor}
              textColor={inputTextColor}
                type="number"
                placeholder="Enter age at onset in months"
                value={individual.medical_data.age_at_onset_months ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_onset_months",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Age at Onset (Years)</FormLabel>
              <Input
              backgroundColor={inputBgColor}
              textColor={inputTextColor}
                type="number"
                placeholder="Enter age at onset in years"
                value={individual.medical_data.age_at_onset_years ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_onset_years",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
          </Flex>

          {/* Age at Diagnosis */}
          <Flex mb={4} direction="row" gap={4}>
            <FormControl>
              <FormLabel>Age at Diagnosis (Months)</FormLabel>
              <Input
              backgroundColor={inputBgColor}
              textColor={inputTextColor}
                type="number"
                placeholder="Enter age at diagnosis in months"
                value={individual.medical_data.age_at_diagnosis_months ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_diagnosis_months",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Age at Diagnosis (Years)</FormLabel>
              <Input
              backgroundColor={inputBgColor}
              textColor={inputTextColor}
                type="number"
                placeholder="Enter age at diagnosis in years"
                value={individual.medical_data.age_at_diagnosis_years ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_diagnosis_years",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
          </Flex>

          {/* Age at Study */}
          <Flex mb={4} direction="row" gap={4}>
            <FormControl>
              <FormLabel>Age at Study (Months)</FormLabel>
              <Input
              backgroundColor={inputBgColor}
              textColor={inputTextColor}
                type="number"
                placeholder="Enter age at study in months"
                value={individual.medical_data.age_at_study_months ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_study_months",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Age at Study (Years)</FormLabel>
              <Input
              backgroundColor={inputBgColor}
              textColor={inputTextColor}
                type="number"
                placeholder="Enter age at study in years"
                value={individual.medical_data.age_at_study_years ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_study_years",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
          </Flex>

          <FormControl mb={4}>
            <FormLabel>Date of Blood Sampling</FormLabel>
            <Flex gap={4}>
              {/* Year of Blood Sampling */}
              <Select
                flex="1"
                value={individual.medical_data.year_of_blood_sampling || ""}
                onChange={(e) => handleChange("medical_data", "year_of_blood_sampling", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Year</option>
                {[...Array(125)].map((_, index) => {
                  const year = new Date().getFullYear() - index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Select>

              {/* Month of Blood Sampling */}
              <Select
                flex="1"
                value={individual.medical_data.month_of_blood_sampling || ""}
                onChange={(e) => handleChange("medical_data", "month_of_blood_sampling", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                  </option>
                ))}
              </Select>

              {/* Day of Blood Sampling */}
              <Select
                flex="1"
                value={individual.medical_data.day_of_blood_sampling || ""}
                onChange={(e) => handleChange("medical_data", "day_of_blood_sampling", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Select>
            </Flex>
          </FormControl>


          <FormControl mb={4}>
            <FormLabel>Date of DNA Extraction</FormLabel>
            <Flex gap={4}>
              {/* Year of DNA Extraction */}
              <Select
                flex="1"
                value={individual.medical_data.year_of_dna_extraction || ""}
                onChange={(e) => handleChange("medical_data", "year_of_dna_extraction", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Year</option>
                {[...Array(125)].map((_, index) => {
                  const year = new Date().getFullYear() - index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Select>

              {/* Month of DNA Extraction */}
              <Select
                flex="1"
                value={individual.medical_data.month_of_dna_extraction || ""}
                onChange={(e) => handleChange("medical_data", "month_of_dna_extraction", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                  </option>
                ))}
              </Select>

              {/* Day of DNA Extraction */}
              <Select
                flex="1"
                value={individual.medical_data.day_of_dna_extraction || ""}
                onChange={(e) => handleChange("medical_data", "day_of_dna_extraction", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Select>
            </Flex>
          </FormControl>


          {/* Genetic Data */}
          {/* Genetic Data */}
          <Heading size="md" mt={6} mb={4}>Genetic Data</Heading>

          <FormControl mb={4}>
            <FormLabel>XP Group</FormLabel>
            <CheckboxGroup
              colorScheme="teal"
              value={
                individual.genetic_data.xp_group.toLowerCase().includes("unknown")
                  ? ["Unknown"]
                  : individual.genetic_data.xp_group.split("|")
              }
              onChange={(values) => {
                let selected = values;
                const wasUnknown = individual.genetic_data.xp_group.toLowerCase().includes("unknown");
                if (values.includes("Unknown")) {
                  if (!wasUnknown) {
                    selected = ["Unknown"];
                  } else if (values.length > 1) {
                    selected = values.filter((v) => v !== "Unknown");
                  }
                }
                const result = selected.includes("Unknown") || selected.length === 0 ? "Unknown" : selected.join("|");
                handleChange("genetic_data", "xp_group", result);
              }}
            >
              <Stack direction="column">
                {xpGroupOptions.map((group) => (
                  <Checkbox key={group} value={group}>
                    {group}
                  </Checkbox>
                ))}
              </Stack>
            </CheckboxGroup>
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Gene Sequencing</FormLabel>
            <Textarea
              placeholder="Enter gene sequencing details"
              value={individual.genetic_data.gene_sequencing || ""}
              onChange={(e) =>
                handleChange("genetic_data", "gene_sequencing", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Exon</FormLabel>
            <Input
            backgroundColor={inputBgColor}
            textColor={inputTextColor}
              placeholder="Enter exon details"
              value={individual.genetic_data.exon || ""}
              onChange={(e) =>
                handleChange("genetic_data", "exon", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Mutation (C)</FormLabel>
            <Input
            backgroundColor={inputBgColor}
            textColor={inputTextColor}
              placeholder="Enter mutation (C)"
              value={individual.genetic_data.mutation_c || ""}
              onChange={(e) =>
                handleChange("genetic_data", "mutation_c", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Mutation (P)</FormLabel>
            <Input
            backgroundColor={inputBgColor}
            textColor={inputTextColor}
              placeholder="Enter mutation (P)"
              value={individual.genetic_data.mutation_p || ""}
              onChange={(e) =>
                handleChange("genetic_data", "mutation_p", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Genotype</FormLabel>
            <Input
            backgroundColor={inputBgColor}
            textColor={inputTextColor}
              placeholder="Enter genotype"
              value={individual.genetic_data.genotype || ""}
              onChange={(e) =>
                handleChange("genetic_data", "genotype", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>NGS</FormLabel>
            <Input
            backgroundColor={inputBgColor}
            textColor={inputTextColor}
              placeholder="Enter NGS data"
              value={individual.genetic_data.ngs || ""}
              onChange={(e) =>
                handleChange("genetic_data", "ngs", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Remarks</FormLabel>
            <Textarea
              placeholder="Enter any additional remarks"
              value={individual.genetic_data.remarks || ""}
              onChange={(e) =>
                handleChange("genetic_data", "remarks", e.target.value || null)
              }
            />
          </FormControl>


          {/* Add more fields here, following the structure from EditIndividual */}

          <Button type="submit" colorScheme="teal" mt={4} backgroundColor={buttonColor}>
            Save Individual
          </Button>
        </form>
      </Box>
    </Flex>
  );
};

export default AddIndividual;
